import { api } from "@/lib/api";
import WarehousePackagesList from "./PackagesList";
import { Layers } from "lucide-react";
import { useWarehousePermissions } from "@/hooks/useWarehousePermissions";

export default function WarehouseReceived() {
  const { can } = useWarehousePermissions();
  return (
    <WarehousePackagesList
      status="RECEIVED_AT_WAREHOUSE,SORTING_IN_WAREHOUSE"
      title="Received Packages"
      description="Packages confirmed at the warehouse. Mark them for sorting or add to a batch."
      action={can("mark_sorting") ? {
        label: "Mark for Sorting",
        testKey: "mark-sorting",
        icon: Layers,
        successMsg: "Marked for sorting.",
        fn: async (pkg) => {
          if (pkg.status === "SORTING_IN_WAREHOUSE") return;
          return api.post(`/warehouse/packages/${pkg.package_id}/mark-sorting`);
        },
      } : null}
    />
  );
}
